<template>
  <div class="tabs-wrap">
    <div class="tabs">
      <button
        type="button"
        :class="['tab', active === 'process' ? 'on' : '']"
        @click="$emit('tab', 'process')"
      >
        Certification Process
      </button>
      <button
        type="button"
        :class="['tab', active === 'practical' ? 'on' : '']"
        @click="$emit('tab', 'practical')"
      >
        Practical Information
      </button>
    </div>

    <div v-show="active === 'process'" class="tabpanel">
      <div class="sec-head">
        <div>
          <span class="eyebrow">What's ahead</span>
          <h2>The certification process</h2>
          <p>
            Six steps from sign-up to certification — no fixed deadlines, go at
            your own pace.
          </p>
        </div>
        <div class="prog">
          <div class="prog-top">
            <b>{{ doneCount }} of {{ steps.length }} steps complete</b>
          </div>
          <div class="prog-bar">
            <div class="prog-fill" :style="{ width: pct + '%' }" />
          </div>
          <div class="prog-foot">
            <span>
              Requirements: complete all 6 steps, attend all 3 days, pass the
              theory exam &amp; submit your GDQ report.
            </span>
            <span v-if="allDone" class="pill-done">
              All steps complete — you're certified!
            </span>
          </div>
        </div>
      </div>

      <ProcessStepper
        :steps="steps"
        :steps-done="stepsDone"
        :substeps-done="substepsDone"
        @step-toggle="$emit('step-toggle', $event)"
        @substep-toggle="$emit('substep-toggle', $event)"
      />

      <div v-if="allDone" class="cert-done">
        <span>✓</span>
        <div>
          <b>Congratulations!</b>
          <div class="cd-sub">
            All 6 steps complete. Your certification is confirmed and your
            certificate is on its way.
          </div>
        </div>
      </div>
    </div>

    <div v-show="active === 'practical'" class="tabpanel">
      <div class="sec-head">
        <div>
          <span class="eyebrow">Know before you go</span>
          <h2>Practical information</h2>
          <p>
            Everything you need to know about location, times and the days
            themselves.
          </p>
        </div>
      </div>
      <PracticalInfo :course="course" />
    </div>
  </div>
</template>

<script>
import ProcessStepper from './ProcessStepper.vue'
import PracticalInfo from './PracticalInfo.vue'

export default {
  name: 'ProcessTabs',
  components: {
    ProcessStepper,
    PracticalInfo
  },
  props: {
    course: {
      type: Object,
      required: true
    },
    stepsDone: {
      type: Array,
      required: true
    },
    substepsDone: {
      type: Array,
      required: true
    },
    active: {
      type: String,
      required: true
    }
  },
  computed: {
    steps () {
      return this.course.steps
    },
    doneCount () {
      return this.steps.filter((s) => this.stepsDone.includes(s.id)).length
    },
    allDone () {
      return this.doneCount === this.steps.length
    },
    pct () {
      return Math.round((this.doneCount / this.steps.length) * 100)
    }
  }
}
</script>

<style scoped>
.tabs-wrap {
  background: var(--white);
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 22px;
  box-shadow: 0 20px 40px -30px rgba(13, 27, 42, 0.35);
}
.tabs {
  display: flex;
  gap: 8px;
  border-bottom: 1px solid var(--line);
  margin-bottom: 18px;
}
.tab {
  background: none;
  border: none;
  padding: 10px 14px;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--ink-soft);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  font-family: inherit;
}
.tab.on {
  color: var(--teal-dk);
  border-bottom-color: var(--teal);
}
.eyebrow {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--teal-dk);
}
.sec-head {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}
.sec-head h2 {
  font-size: 1.55rem;
  letter-spacing: -0.01em;
  margin: 4px 0 6px;
}
.sec-head p {
  color: var(--ink-soft);
  font-size: 0.95rem;
  margin: 0;
}
.prog {
  min-width: 260px;
  flex: 0 1 300px;
}
.prog-top b {
  font-size: 0.95rem;
}
.prog-bar {
  height: 8px;
  border-radius: 99px;
  background: var(--paper-2);
  overflow: hidden;
  margin: 8px 0 6px;
}
.prog-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--teal), var(--ok));
  border-radius: 99px;
  transition: width 0.4s ease;
}
.prog-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font-size: 0.78rem;
  color: var(--ink-soft);
}
.pill-done {
  background: #e5f5ec;
  color: #12744a;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 99px;
  white-space: nowrap;
}
.cert-done {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #e5f5ec;
  border: 1px solid #bfe5d0;
  border-radius: 12px;
  padding: 14px 16px;
  margin-top: 16px;
  color: #12744a;
}
.cert-done span {
  font-size: 1.3rem;
  font-weight: 800;
}
.cd-sub {
  font-size: 0.88rem;
  font-weight: 400;
}
</style>
